// Copyright: IQGeo Limited 2010-2019
import _ from 'underscore';
import myw from 'myWorld-base';
import './layerEditor';

myw.OgcLayerEditor = myw.LayerEditor.extend({
    messageGroup: 'DefineLayerControl',
    tabs: [
        {
            id: 'properties-layers-tab',
            title: '{:properties}'
        },
        {
            id: 'advanced-layers-tab',
            title: '{:advanced}'
        },
        {
            id: 'general-layers-tab',
            title: '{:general}'
        }
    ],

    renderAdvanced(table) {
        const rowDefs = [
            {
                label: '{:wmsLayerGroup}:',
                components: [new myw.Input({ name: 'wmsLayerGroup' })]
            },
            {
                label: '{:wfsUrl}:',
                components: [new myw.Input({ name: 'wfsUrl', cssClass: 'block' })]
            },
            {
                label: '{:wfsVersion}:',
                components: [
                    new myw.Dropdown({ name: 'wfsVersion', options: ['1.0.0', '1.1.0', '2.0.0'] })
                ]
            },
            {
                label: '{:tunnelled}:',
                components: [new myw.Checkbox({ name: 'tunnelled' })]
            },
            {
                name: 'control_item_legend',
                label: '{:control_item_legend}:',
                components: [new myw.Checkbox({ name: 'control_item_legend' })]
            }
        ];

        this._renderRows(table, rowDefs);
    },

    formValuesToLayerDef(formValues) {
        const def = myw.LayerEditor.prototype.formValuesToLayerDef.call(this, formValues);
        _.extend(def.datasource_spec, _.pick(formValues, 'wfsUrl', 'wfsVersion', 'tunnelled'));
        def.datasource_spec.wmsUrl = formValues.url;
        def.wmsLayerGroup = formValues.wmsLayerGroup;
        return def;
    },

    layerDefToFormValues(layerDef) {
        const values = myw.LayerEditor.prototype.layerDefToFormValues.call(this, layerDef);
        values.url = layerDef.datasource_spec.wmsUrl;
        return values;
    },

    onUrlChange() {
        const url = this.formInputs['url'].getValue();
        if (url.includes('wms')) {
            const wfsUrl = url.replace('wms', 'wfs');
            this.formInputs['wfsUrl'].setValue(wfsUrl);
        }
    }
});

myw.layerEditors['ogc'] = myw.OgcLayerEditor;

export default myw.OgcLayerEditor;
